import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { WithdrawalcoinlistPage } from './withdrawalcoinlist';

@NgModule({
  declarations: [
    WithdrawalcoinlistPage,
  ],
  imports: [
    IonicPageModule.forChild(WithdrawalcoinlistPage),
  ],
})
export class WithdrawalcoinlistPageModule {}



// WEBPACK FOOTER //
// ./src/pages/withdrawalcoinlist/withdrawalcoinlist.module.ts